import { render, staticRenderFns } from "./KPIs.vue?vue&type=template&id=14cc86d8&"
import script from "./KPIs.vue?vue&type=script&lang=ts&"
export * from "./KPIs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports